import { Hubs, HubSplitSection as HubSplitSectionType } from 'utils/gloo-types';
import classNames from 'classnames';
import { HubPreviewView } from 'pages/_AdminAuthoringPages/_components/HubPreview';
import HubSectionDescription from './HubSectionDescription';
import HubSectionTitle from './HubSectionTitle';
import HubSplitSectionContent from './HubSplitSectionContent';

interface HubSplitSectionProps {
  hub: Hubs;
  hubSplitSection: HubSplitSectionType;
  previewView?: HubPreviewView;
}

const HubSplitSection = ({
  hub,
  hubSplitSection: { title, titleColor, description, descriptionColor, a, b },
  previewView,
}: HubSplitSectionProps) => {
  const isDesktopView = previewView === HubPreviewView.Desktop;
  const isMobileView = previewView === HubPreviewView.Mobile;

  return (
    <div
      className={classNames('m-auto max-w-[1204px] flex flex-col', {
        'gap-5 xl:gap-8': !previewView,
        'gap-8': isDesktopView,
        'gap-5': isMobileView,
      })}
    >
      <div className="flex flex-col gap-2">
        <HubSectionTitle title={title} titleColor={titleColor} />
        <HubSectionDescription description={description} descriptionColor={descriptionColor} />
      </div>
      <div
        className={classNames('flex gap-5', {
          'flex-col xl:flex-row': !previewView,
          'flex-row': isDesktopView,
          'flex-col': isMobileView,
        })}
      >
        <HubSplitSectionContent hub={hub} content={a} />
        <HubSplitSectionContent hub={hub} content={b} />
      </div>
    </div>
  );
};

export default HubSplitSection;
